import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'lives',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  emptyMessage: "You don't have live events enabled, go to the live events section and set one to enable the 'Live Scheduled Enabled'.",
  fields: [
    {
      attributeName: 'id',
      label: 'ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:false,
      canEdit: false,
      canCreate: false,
      helpText: 'Live event ID.',
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:false,
      canEdit: false,
      canCreate: false,
      helpText: 'Live event name.',
    },
    {
      attributeName: 'deployment',
      label: 'Deployment',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:false,
      canEdit: false,
      canCreate: false,
      helpText: 'Deployment linked to live event.',
    },
  ],
};
